import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import content from '@/content'

Vue.use(Vuex)

const state = {
  keyword: '',
  content,
  user: {
    visitCount: 0,
    calculator: {
      length: 6,
      width: 3,
      fleece: false
    },
    isB2B: false,
    playedVideo: false
  }
}

const getters = {
  getContent: state => (page, keyword) => {
    if (typeof keyword === 'undefined') {
      return state.content[page].default
    }
    if (typeof state.content[page][keyword] === 'undefined') {
      return state.content[page].default
    }
    return state.content[page][keyword]
  },
  visitCount (state) {
    return state.user.visitCount
  },
  playedVideo (state) {
    return state.user.playedVideo
  },
  getCalculator (state) {
    return state.user.calculator
  },
  isB2B (state) {
    return state.user.isB2B
  },
  keyword (state) {
    return state.keyword
  }
}

const mutations = {
  INCREMENT_VISIT_COUNT (state) {
    state.user.visitCount++
  },
  SET_PLAYED_VIDEO_TRUE (state) {
    state.user.playedVideo = true
  },
  USER_IS_B2B (state, boolean) {
    state.user.isB2B = boolean
  },
  SAVE_CALCULATOR (state, formData) {
    state.user.calculator = formData
  },
  SET_KEYWORD (state, keyword) {
    state.keyword = keyword
  }
}

const actions = {
  viewPage ({ commit }) {
    commit('INCREMENT_VISIT_COUNT')
  },
  playVideo ({ commit }) {
    commit('SET_PLAYED_VIDEO_TRUE')
  },
  b2bUser ({ commit }, boolean) {
    commit('USER_IS_B2B', boolean)
  },
  saveCalculator ({ commit }, formData) {
    commit('SAVE_CALCULATOR', formData)
  },
  setKeyword ({ commit }, keyword) {
    commit('SET_KEYWORD', keyword)
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js